<template>
  <div class="wrapper f1 df fdrr">

    <div class="page1 f1 df fdc">

    <div class="profile-photo-details df fdc jcc w100p">
      <p class="profile-top-name">
        Pricing Plans
      </p>
      <p class="profile-top-email df jcsb f1">
        <span>
          Select your desired plan below
        </span>
        <span>
          All prices in USD
        </span>
      </p>
    </div>

      <div class="pricing-plans df">

        <!-- <p class="plan-heading">Project Management Plans</p> -->
        <div class="box pricing-plan df fdr jcsb"
                    v-bind:class="{'current-plan-background' : !$store.getters.companyPlan || isCurrentPlan('free')}">
          <span class="f2 df fdc aic jcsb plan-title">
            <img src="/images/plan-icons/Watch-Icon.png" alt="">
            <p>Free</p>
            <p class="plan-price">$0<span class="sup">/mo</span></p>
            <span class="horizontal-spacer"></span>
            <p class="pricing-plan-info f1">
              1 pricing project
            </p>
            <button class="button button-1 button-black" @click.prevent="isCurrentPlan('free')"
            v-on:click="goTo('/changeplanfree')"
                    v-bind:class="{'current-plan-button': isCurrentPlan('free')}">
              {{$store.getters.upgradeOrDowngrade('free')}}
            </button>
          </span>
          <!-- <span class="pricing-plan-right df fdr f4 jcsb">
            <span class="df fdc f1 jcsb">
              <p class="f1">Projects</p>
              <p class="f1 number-of-things">1</p>
            </span>
            <span class="df fdc f1 jcsb">
              <p class="f1">
                Features
              </p>
              <p class="f1">
                <span class="feature">Edit company</span>
                <span class="feature">Edit task rates</span>
                <span class="feature">Edit resources</span>
              </p>
            </span>
          </span> -->
        </div>
        <!-- <p class="plan-heading">Upgrade Plan</p> -->
        <div class="box pricing-plan df fdr jcsb"
                    v-bind:class="{'current-plan-background' : isCurrentPlan('plan_G91aW03VrSu7x8')}">
          <span class="f2 df fdc aic jcsb plan-title">
            <img src="/images/plan-icons/Alarm-Clock-Icon.png" alt="">
            <p>Basic</p>
            <p class="plan-price">$25<span class="sup">/mo</span></p>
            <span class="horizontal-spacer"></span>
            <p class="pricing-plan-info f1">
              5 pricing projects
            </p>
            <button class="button button-1 button-black" @click.prevent="isCurrentPlan('plan_G91aW03VrSu7x8')"
            v-on:click="goTo('/changeplanbasic')"
                    v-bind:class="{'current-plan-button': isCurrentPlan('plan_G91aW03VrSu7x8')}">
              {{$store.getters.upgradeOrDowngrade('plan_G91aW03VrSu7x8') }}
            </button>
          </span>
          <!-- <span class="pricing-plan-right df fdr f4 jcsb">
            <span class="df fdc f1 jcsb">
              <p class="f1">Projects</p>
              <p class="f1 number-of-things">5</p>
            </span>
            <span class="df fdc f1 jcsb">
              <p class="f1">
                Features
              </p>
              <p class="f1">
                <span class="feature">Edit company</span>
                <span class="feature">Edit task rates</span>
                <span class="feature">Edit resources</span>
                <span class="feature">Phases</span>
                <span class="feature">Export to Excel</span>
              </p>
            </span>
          </span> -->
        </div>
        <div class="box pricing-plan df fdr jcsb"
                    v-bind:class="{'current-plan-background' : isCurrentPlan('plan_G91cFxeIzg5lCq')}">
          <span class="f2 df fdc aic jcsb plan-title">
            <img src="/images/plan-icons/Clock-Icon.png" alt="">
            <p>Unlimited</p>
            <p class="plan-price">$150<span class="sup">/mo</span></p>
            <span class="horizontal-spacer"></span>
            <p class="pricing-plan-info f1">
              Unlimited projects
            </p>
            <button class="button button-1 button-black" @click.prevent="isCurrentPlan('plan_G91cFxeIzg5lCq')"
            v-on:click="goTo('/changeplan')"
                    v-bind:class="{'current-plan-button': isCurrentPlan('plan_G91cFxeIzg5lCq')}">
              {{$store.getters.upgradeOrDowngrade('plan_G91cFxeIzg5lCq') }}
            </button>
          </span>
          <!-- <span class="pricing-plan-right df fdr f4 jcsb">
            <span class="df fdc f1 jcsb">
              <p class="f1">Unlimited Projects</p>
              <p class="f1 number-of-things">&nbsp;</p>
            </span>
            <span class="df fdc f1 jcsb">
              <p class="f1">
                Features
              </p>
              <p class="f1">
                <span class="feature">Edit task rates</span>
                <span class="feature">Edit resources</span>
                <span class="feature">Phases</span>
                <span class="feature">Export to Excel</span>
                <span class="feature">Harvest Integration</span>
                <span class="feature">Export to Sheets</span>
                <span class="feature">Data Analysis</span>
              </p>
            </span>
          </span> -->
        </div>

      </div>


    </div>
    <SideBarProfile v-bind:page="'pricing'" v-bind:editingCompany="'no'"/>
  </div>
</template>

<script>
import SideBarProfile from '../elements/SideBarProfile'
import router from '../../router'

export default {
  name: 'DashboardPricing',
  data () {
    return {
      // mode: 'login' // login/register
    }
  },
  props: [],
  components: {
    SideBarProfile,
    SideBarProfile
  },
  methods: {
    goTo (path) {
      router.push(path)
    },
    isCurrentPlan(plan){
      return this.$store.getters.upgradeOrDowngrade(plan) === 'current plan'
    },
    goToIf (path, plan) {
      if(this.isCurrentPlan(plan)){
        this.goTo(path)
      }
    },
  },
  computed: {

  },
  created () {
    // console.log('** Login Component Loaded')
    window.scrollTo(0)
  }
}
</script>

<style scoped lang="scss">
@import "../../styles/settings.scss";


//
// Wrapper
//
.wrapper {
  display: flex;
  flex-wrap: wrap;
  flex-direction: row-reverse;
  padding-left: 50px;
  padding-right: 50px;

  // Responsive Style
  // @media max-width: 768px
  @media(max-width: 768px) {
    flex-direction: column-reverse;
    padding-left: 0px;
    padding-right: 0px;
  }
}


//
// Page 1
//
.page1 {
  width: calc(100% - 274px);

  // Responsive Style
  // @media max-width: 1024px
  @media(max-width: 1024px) {
    padding-left: 20px;
    padding-right: 20px;
  }

  // Responsive Style
  // @media max-width: 768px
  @media(max-width: 768px) {
    width: 100%;
  }
}


//
// Pricing Plans
//
.pricing-plans {
  // Responsive Style
  // @media max-width: 920px
  @media(max-width: 920px) {
    flex-wrap: wrap;
  }
}


//
// Pricing Plan
//
.pricing-plan {
  /*min-height: 210px;*/
  height: 305px;
  width: 195px;
  padding: 32px 28px 16px;
  margin-bottom: 50px;
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -webkit-flex-direction: column;
  -moz-flex-direction: column;
  -ms-flex-direction: column;
  -o-flex-direction: column;
  flex-direction: column;
  margin-right: 15px;

  &:last-of-type {
    margin-right: 0;
  }

  // Responsive Style
  // @media max-width: 920px
  @media(max-width: 920px) {
    width: 100%;
    margin-right: 0px;
    margin-bottom: 20px;
  }
}


.pricing-plan-left {
  background-color: #D9EDFF;
  border-top-left-radius: 10px;
  border-bottom-left-radius: 10px;
  padding: 40px 0;
}
.pricing-plan-right {
  & > span {
    padding: 40px;
    &:last-child {
      & > p {
        &:first-child {
          margin-bottom: 40px;
        }
      }
    }
  }
}
.feature {
  display: block;
  margin-bottom: 4px;
}
.number-of-things {
  color: #000000;
  font-size: 48px;
  line-height: 57px;
}
.plan-title {
  color: $grey2;
  font-size : 18px;
  text-transform: uppercase;
  font-weight: 600;
  font-family: 'Nexa';

  & > p {
    margin-top: 10px;
    font-family: 'Nexa';
    &:first-of-type {
      opacity: 0.4;
    }
    /*&:first-child {*/
      /*opacity: 0.4;*/
    /*}*/
  }

  .pricing-plan-info {
    margin-top: 0;
  }

  .plan-price {
    margin-top: 10px;
  }
}
.plan-price {
  color: #000000;
  font-size: 24px;
  /*line-height: 57px;*/
  position: relative;
  text-align: center;
  margin-top: 0px;
  font-family: 'Nexa';
  color: $grey2;

  & > .sup {
    /*position: absolute;*/
    /*top: 50%;*/
    font-family: 'Nexa';
    text-transform: uppercase;
    color: #000000;
    font-size: 12px;
    line-height: 4px;
    color: $grey2;
  }
}
.plan-heading {
  color: #000000;
  font-size: 24px;
  line-height: 43px;
  margin-bottom: 5px;
}
.current-plan-background {
  /*background-color: #cac1ff;*/
  border-radius: 10px;
  border: 2px solid $primaryColor;
}
.button-black {
  width: unset;
  height: 32px;
  background-color: $primaryColor;
  color: white;
  font-family: 'GG';
  font-size: 12px;
  font-weight: 500;
  text-transform: capitalize;
  width: 100%;
  /*background: transparent;*/
}
.pricing-plan-info {
  font-family: 'GG';
  color: $grey2;
  font-size: 12px;
  font-weight: 300;
  text-transform: none;
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  justify-content: center;
  -ms-align-items: center;
  align-items: center;
}
.current-plan-button {
  border: none;
  background-color: $greyBoxGrey;
  color: $grey2;
}
.horizontal-spacer {
  margin-top: 20px;
  width: 44px;
  height: 2px;
  background-color: $grey4;
}
.w100p {
  width: 100%;
}

.profile-photo-details {
  /*height: 50px;*/
  margin-bottom: 30px;
  max-width: 612px;
}
.profile-top-name {
  font-family: 'Nexa';
  font-weight: 600;
  font-size: 24px;
  color: $grey2;
  margin-bottom: 6px;
}

//
// Profile top email
//
.profile-top-email {
  font-family: 'GG';
  font-weight: 400;
  font-size: 16px;
  color: $grey2;

  // Responsive Style
  // @media max-width: 768px
  @media(max-width: 768px) {
    display: block;

    // span
    span {
      display: block;
      font-size: 16px;
      &:last-child {
        font-size: 12px;
        margin-top: 15px;
        margin-bottom: -20px;
        text-align: center;
      }
    }
  }
}
</style>
